import styled, {css} from 'styled-components'

import theme, {media} from '@/src/config/theme'

import Button from '@/src/shared/ui/button'
import {Input} from '@/src/shared/ui/inputs/input'

export const Component = styled.div`
  .product-card .to-wish {
    display: inline-block;
    vertical-align: middle;
    margin-left: 55px;
    margin-right: auto;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.5);
    position: relative;
    font-size: 16px;
    text-decoration: none;
    color: #000;
    width: 84px;
    white-space: nowrap;
  }

  .product-card .to-wish:hover {
    color: #ffcc08;
    border-bottom-color: #ffcc08;
  }

  .product-card .to-wish:after {
    content: '';
    display: block;
    width: 32px;
    height: 32px;
    position: absolute;
    right: 100%;
    top: 50%;
    margin-right: 10px;
    transform: translateY(-50%);
    background: url(data:image/png;base64,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)
      no-repeat 50% / contain;
  }

  .product-card .to-wish.already-in-wish:after {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABYCAYAAAAKsfL4AAAFJ0lEQVR42u2de4hNQRzHZ62165GIJEQojySPJOIvhfyn/KG8aW0e2WUjS97PvNbaPPJM2ybPkNhN/CGlhJINIVGeKSH+YO/dPX5jZ3Udv3PunHvPzJy59zf12bZz7z3nN9/vzJm5M3PmMqYwOfcLWgN9gaHAGMEwoDuQyyKSeCxADxFbc5xDgD5AAbMhiUyMAlYDNcBroBFwPPgFPAaqgPlAT42x9gKKxLWfAPU+cTYAr4BrwCpgJNAiSsIPBsqBjz6ZkOUesATooCDOjkAxcD+EON8Du4FBJoUfC9SGkBmM78AeoEsIcXYRBeSHolivAqN1Ct8TuCQRWKOo2o0e1bpe0ogyIC+FOFuJ26GM8DERU5A8uDnP2xHV4i9KkqF4GiUp5vPaI94oBoiTN/p1KV4rGfEkBaZIhfDtgbMKRPdq9LDjP4FCiVjni/cGOXfYZpwC2oUlflfgoUf1dBTilTne+OUgceaIe72OQiKjxYO02zDRXXsZchUOw4hjiSbwbiFwQkOJD3oLfZFy9xo+2Bl4pjEDQTNXmRDrfsOFxI+nQKeg4hcAdyOSAb/SXAIsM3DLCcod3isLYsChiGXAy4Q4InZDRGOvlBV/SkQzIHNriUU89sky3c0PEc+El9BxC+J+69s9hRf3WlaiHAsLy24v8XuIEUoSTS38S2I3zIAKzV+0wmqUGyyI063lHrf47RSOFhL4mFHbRAPmWFj6bcOt6YxEA26QQNqpbRa/javxjZM4Wsa1fv6Zb4Y/40kYY4zjBqwjIYyxhonJAxLDDNVMTByQGGa4xw14Rw2wsYb4DTfgW8KBehJI69jQV+b6Kk8G6DUgzlwHaPRTPYmFvJ4b8IUMMFYDPjPXxDuNAekdE3rKDbhOohijhhuwj4QwRjk3YBYJYYzp3IDeNA9spAfk/F01B/88J3G08yRxQmYbCaKdzYkGDLBwjY3NY0Ccfu6J+ZskkjZuYMtSJlIt0Fb6x3stzrpNqyOUr4a45bc0cYQlC51shWs7PNkC3QqqBcpKf7ns9gKP6ctZ6Ity66S3PYA3DnTNlJEJ6YnPtewf9DGlSciJyITg4vPhhwmpPqg3DWmUyQR58Xn3c2q6j6rOREyguePkA20Nf0Y7Q3pYew6ZEFj8mWFvVzAP6VaRCbj4s1Vt1lGImBCje/4//f65qndMKaKa4Cl+IdOR4EILJapiNt12uPhFTGeCCy7OUhMw8ReY2rasOMtMwPK2yPSmfUst3DIgLPGXRGXnxNIMNwHLS0nU9g1dkaEmYHkojermrWUZ1iZgsS+P+g66qzOkJmAxr7RlG+O1lpuAxbqK2ZQg4A2WmhBDHye1MUHgmywzAYttPbM5QQa2WmICFtNGlgkJMrI94iZgsWxhmZQgQzsjagIWwzaWiclp2pI+SiZg197BMjk5/28MaMoE7Jq7WDYkj+fSdC4GjqPPa2VTcvD9nuOGxK9g2Zacpu3mD2o2ATt3JcvWJEw47LGKWMXKZPexAyzbkzDhqGITsHPxDcpzGKW/JhxXZAJ2jiMk/v8m8F/BOBmyCdhnj5H4/iZUhWQC9pkTJL6cCdVpmoC9l9euFqSwnAm5Hrs5yjwuhb2nisRPzYTTAU3AXqsm8VM3oSVwTlJo7BivRbmkZPomXEgiOCb+GRI/PBPygIuIyJ8E7uO81rQk5cI34bJEI3yBxFdnAv+J2is+4vNakkdKqTfhKiL+ZRJfnwn5TtNvvDeLz2tFK1JGvwk1woh8UsSMCQW2i/8bHc7UYj/6G9wAAAAASUVORK5CYII=);
  }

  .product-card {
    flex-direction: column;
  }

  @media only screen and (min-width: 481px) {
    .product-card {
      margin-bottom: 55px;
    }
  }

  @media (${media.md}) {
    .product-card {
      flex-direction: row;
    }
  }

  @media only screen and (min-width: 481px) {
    .product-card--main-col {
      width: calc(100% - 320px);
      max-width: 825px;
      margin-top: 20px;
    }
  }

  @media only screen and (min-width: 481px) {
    .product-card--aside {
      width: 300px;
    }
  }

  @media only screen and (min-width: 481px) and (max-width: 800px) {
    .product-card--aside {
      width: 275px;
    }
  }

  .product-card--header,
  .product-card--header .group {
    display: -ms-flex;
    display: -webkit-flex;
    display: flex;
  }

  .product-card--header .group {
    -webkit-justify-content: space-between;
    justify-content: space-between;
  }

  .product-card--header .card-icons {
    margin-top: 6px;
    margin-left: 40px;
    white-space: nowrap;
  }

  @media only screen and (max-width: 800px) and (min-width: 481px) {
    .product-card--header .card-icons {
      margin-top: 8px;
    }
  }

  .product-card--header .card-heading {
    font-size: 38px;
    font-weight: 500;
  }

  @media only screen and (max-width: 800px) and (min-width: 481px) {
    .product-card--header .card-heading {
      font-size: 30px;
    }
  }

  .product-card--article {
    font-size: 12px;
    margin-top: 22px;
    white-space: nowrap;
  }

  @media only screen and (max-width: 800px) and (min-width: 481px) {
    .product-card--article {
      margin-top: 15px;
    }
  }

  @media only screen and (min-width: 481px) {
    .product-card--section + .product-card--section {
      margin-top: 3em;
    }
  }

  @media only screen and (max-width: 480px) {
    .product-card--section + .product-card--section {
      margin-top: -1px;
    }
  }

  @media only screen and (max-width: 480px) {
    .wrapper > .product-card--section {
      margin-top: -1px;
    }
  }

  .product-card--section-caption {
    font-weight: 500;
    font-size: 24px;
  }

  @media only screen and (min-width: 481px) {
    .product-card--section-caption {
      margin-bottom: 8px;
    }

    .product-card--section-caption.big-caption {
      font-size: 33px;
      line-height: 1;
    }
  }

  .product-card--section-content {
    font-size: 18px;
    line-height: 1.4;
  }

  .product-card--section-content > * + * {
    margin-top: 1.8em;
  }

  .product-card--section-content_spoiler {
    overflow: hidden;
    position: relative;
    padding-bottom: 20px;
    box-sizing: border-box;
    transition: max-height 0.25s ease;
  }

  .product-card--section-content_spoiler.is-collapsible {
    margin-bottom: 45px;
  }

  .product-card--section-content_spoiler.is-collapsible:after {
    content: '';
    display: block;
    width: 100%;
    height: 100px;
    background: -moz-linear-gradient(
      top,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.7) 55%,
      rgba(255, 255, 255, 0.8) 65%,
      #fff 75%,
      #fff 100%
    );
    background: -webkit-linear-gradient(
      top,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.7) 55%,
      rgba(255, 255, 255, 0.8) 65%,
      #fff 75%,
      #fff 100%
    );
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.7) 55%,
      rgba(255, 255, 255, 0.8) 65%,
      #fff 75%,
      #fff 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 );
    position: absolute;
    left: 0;
    bottom: 0;
    transition: opacity 0.25s ease;
  }

  .product-card--section-content_spoiler.is-collapsible:not(.is-expanded) {
    max-height: 200px;
  }

  .product-card--section-content_spoiler.is-collapsible.is-expanded {
    max-height: 5000px;
  }

  .product-card--section-content_spoiler.is-collapsible.is-expanded:after {
    display: none;
  }

  .product-card--section-content-toggler {
    display: none;
    position: absolute;
    left: 50%;
    bottom: 0;
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    z-index: 2;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.5);
  }

  .product-card--section-content_spoiler.is-collapsible .product-card--section-content-toggler {
    display: block;
  }

  .product-card--section-content-toggler:hover {
    color: #ffcc08;
    border-bottom-color: rgba(255, 204, 8, 0.5);
  }

  .product-card--section-content_spoiler.is-expanded .product-card--section-content-toggler .collapsed-text {
    display: none;
  }

  .product-card--section-content_spoiler:not(.is-expanded) .product-card--section-content-toggler .expanded-text {
    display: none;
  }

  .product-card .product-colors {
    display: -ms-flex;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-bottom: 50px;
  }

  .product-card .product-colors a {
    display: block;
    width: calc(25% - 5px);
    margin-right: 5px;
    position: relative;
    box-sizing: border-box;
    border: 1px solid transparent;
  }

  .product-card .product-colors a.active {
    border-color: #ffcc08;
  }

  .product-card .product-colors a:before {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  .product-card .product-colors a img {
    max-width: 95%;
    max-height: 95%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .product-card .size-choice-block {
    margin-left: 2.5px;
    margin-bottom: 5px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 10px;

    button {
      white-space: nowrap;
    }
  }

  .product-card .product-old-price-block,
  .product-card .product-old-price-block .old-price {
    font-size: 18px;
    font-weight: normal;
  }

  .product-card .product-price-block,
  .product-card .product-price-block .product-price {
    font-size: 27px;
    font-weight: 500;
  }

  @media only screen and (max-width: 480px) {
    .product-card .product-price-block {
      margin-bottom: 0 !important;
    }

    .product-card .product-price-block .product-price {
      padding-top: 5px;
    }
  }

  .product-card .product-price-block .product-price {
    font-weight: 600;
  }

  .product-card--action-link {
    display: inline-block;
    font-size: 18px;
    line-height: 0.9;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.5);
    margin-top: 15px;
    text-decoration: none;
    color: #000;
  }

  .product-card--action-link:hover {
    border-bottom-color: rgba(255, 204, 8, 0.5);
  }

  @media only screen and (min-width: 481px) {
    .product-card-aside--block:not(.empty-block) + .product-card-aside--block {
      margin-top: 32px;
    }
  }

  @media only screen and (max-width: 480px) {
    .product-card-aside--block:not(.empty-block) + .product-card-aside--block {
      margin-top: -1px;
    }
  }

  .product-card-aside--block .subcaption {
    font-size: 18px;
    font-weight: 500;
  }

  @media only screen and (min-width: 481px) {
    .product-card-aside--block .subcaption {
      margin-bottom: 6px;
    }
  }

  .product-card-aside--block .block--content {
    font-size: 18px;
    line-height: 1.4;
  }

  @media only screen and (max-width: 480px) {
    .product-card-aside--block .block--content {
      font-size: 14px;
      line-height: 2;
    }
  }

  .product-card-aside--block .block--content a {
    display: inline-block;
    color: #000;
    text-decoration: none;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.5);
    line-height: 0.9;
  }

  .product-card-aside--block .block--content a:hover {
    color: #ffcc08;
    border-bottom-color: rgba(255, 204, 8, 0.5);
  }

  .product-card-aside--block .block--content .warehouses-list-block a {
    border-bottom-style: solid;
  }

  .one-row-vitrine-wrapper {
    margin-bottom: -70px;
    position: relative;
  }

  @media only screen and (min-width: 481px) {
    .one-row-vitrine-wrapper {
      padding: 0 !important;
    }
  }

  @media only screen and (max-width: 480px) {
    .one-row-vitrine-wrapper .vitrine {
      display: block;
    }
  }

  .one-row-vitrine-wrapper .vitrine-prev,
  .one-row-vitrine-wrapper .vitrine-next {
    width: 40px;
    height: 45px;
    position: absolute;
    top: 175px;
    z-index: 100;
  }

  .one-row-vitrine-wrapper .vitrine-prev:not(.tos-disabled),
  .one-row-vitrine-wrapper .vitrine-next:not(.tos-disabled) {
    cursor: pointer;
  }

  .one-row-vitrine-wrapper .vitrine-prev.tos-disabled,
  .one-row-vitrine-wrapper .vitrine-next.tos-disabled {
    display: none;
  }

  .one-row-vitrine-wrapper .vitrine-prev:before,
  .one-row-vitrine-wrapper .vitrine-next:before {
    content: '';
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50%;
    border-top: 2px solid #d6d9db;
  }

  .one-row-vitrine-wrapper .vitrine-prev {
    left: 5px;
  }

  .one-row-vitrine-wrapper .vitrine-prev:before {
    left: 50%;
    border-left: 2px solid #d6d9db;
    -moz-transform: rotate(-45deg) translate(-50%, -50%);
    -ms-transform: rotate(-45deg) translate(-50%, -50%);
    -o-transform: rotate(-45deg) translate(-50%, -50%);
    -webkit-transform: rotate(-45deg) translate(-50%, -50%);
    transform: rotate(-45deg) translate(-50%, -50%);
    transform-origin: top left;
  }

  .one-row-vitrine-wrapper .vitrine-next {
    right: 5px;
  }

  .one-row-vitrine-wrapper .vitrine-next:before {
    right: 50%;
    border-right: 2px solid #d6d9db;
    -moz-transform: rotate(45deg) translate(50%, -50%);
    -ms-transform: rotate(45deg) translate(50%, -50%);
    -o-transform: rotate(45deg) translate(50%, -50%);
    -webkit-transform: rotate(45deg) translate(50%, -50%);
    transform: rotate(45deg) translate(50%, -50%);
    transform-origin: top right;
  }

  .one-row-vitrine-wrapper .vitrine {
    position: relative;
  }

  .one-row-vitrine-wrapper .vitrine:hover {
    z-index: 101;
  }

  .one-row-vitrine .product {
    width: 100%;
    margin-bottom: 85px;
  }

  @media only screen and (max-width: 480px) {
    .one-row-vitrine .product {
      margin-bottom: 145px;
    }
  }

  .one-row-vitrine .product:hover {
    background: #fff;
  }

  .product-card .product-image {
    position: relative;
  }

  @media only screen and (max-width: 480px) {
    .product-card .product-image {
      padding-top: 30px;
      padding-bottom: 5px;
    }

    .product-card .product-image .product-main-pic {
      padding-bottom: 56%;
    }
  }

  .product-main-pic-prev,
  .product-main-pic-next {
    display: none;
    width: 40px;
    height: 45px;
    position: absolute;
    top: 50%;
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .product-main-pic-prev:before,
  .product-main-pic-next:before {
    content: '';
    display: block;
    width: 30px;
    height: 30px;
    border-top: 2px solid #575757;
    position: absolute;
    top: 50%;
  }

  .product-main-pic-prev.is-disabled,
  .product-main-pic-next.is-disabled {
    opacity: 0.5;
  }

  .product-main-pic-prev:not(.is-disabled),
  .product-main-pic-next:not(.is-disabled) {
    cursor: pointer;
  }

  @media only screen and (max-width: 480px) {
    .product-main-pic-prev,
    .product-main-pic-next {
      display: none !important;
    }
  }

  .product-main-pic-prev {
    left: 0;
  }

  .product-main-pic-prev:before {
    left: 50%;
    border-left: 2px solid #575757;
    -moz-transform: rotate(-45deg) translate(-30%, -30%);
    -ms-transform: rotate(-45deg) translate(-30%, -30%);
    -o-transform: rotate(-45deg) translate(-30%, -30%);
    -webkit-transform: rotate(-45deg) translate(-30%, -30%);
    transform: rotate(-45deg) translate(-30%, -30%);
    transform-origin: top left;
  }

  .product-main-pic-next {
    right: 0;
  }

  .product-main-pic-next:before {
    right: 50%;
    border-right: 2px solid #575757;
    -moz-transform: rotate(45deg) translate(30%, -30%);
    -ms-transform: rotate(45deg) translate(30%, -30%);
    -o-transform: rotate(45deg) translate(30%, -30%);
    -webkit-transform: rotate(45deg) translate(30%, -30%);
    transform: rotate(45deg) translate(30%, -30%);
    transform-origin: top right;
  }

  .card-btn.callback-btn {
    width: auto;
    padding: 0 52px;
    white-space: nowrap;
  }

  @media only screen and (min-width: 481px) {
    .mobile-back {
      display: none;
    }
  }

  @media only screen and (max-width: 480px) {
    .card-breadcrumbs {
      display: none;
    }

    .mobile-back {
      display: block;
      padding: 10px 36px 10px 36px;
      border-bottom: 1px solid #d7d7d7;
      position: relative;
      font-size: 14px;
      text-decoration: none;
      text-align: center;
      color: #000;
    }

    .mobile-back:before {
      content: '';
      display: block;
      width: 7px;
      height: 7px;
      border-top: 2px solid #d7d7d7;
      border-left: 2px solid #d7d7d7;
      position: absolute;
      left: 20px;
      top: 50%;
      -moz-transform: rotate(-45deg) translate(-50%, -50%);
      -ms-transform: rotate(-45deg) translate(-50%, -50%);
      -o-transform: rotate(-45deg) translate(-50%, -50%);
      -webkit-transform: rotate(-45deg) translate(-50%, -50%);
      transform: rotate(-45deg) translate(-50%, -50%);
      transform-origin: top left;
    }

    .mobile-card-caption {
      padding-bottom: 15px;
    }

    .mobile-card-caption .card-heading {
      font-size: 18px;
      font-weight: 500;
    }

    .mobile-card-caption .product-card--article {
      font-size: 12px;
      margin-top: 10px;
    }

    .product-card--section-caption,
    .product-card-aside--block .subcaption {
      font-size: 14px;
      font-weight: normal;
      text-align: center;
      padding: 15px 25px;
      border-top: 1px solid #b7b6b6;
      border-bottom: 1px solid #b7b6b6;
      margin-left: -10px;
      margin-right: -10px;
      position: relative;
    }

    .product-card--section-caption:after,
    .product-card-aside--block .subcaption:after {
      content: '';
      display: block;
      width: 5px;
      height: 5px;
      border-bottom: 3px solid #d7d7d7;
      border-right: 3px solid #d7d7d7;
      position: absolute;
      right: 12px;
      top: 50%;
    }

    .product-card--section-content,
    .product-card-aside--block .block--content {
      overflow: hidden;
      max-height: 5000px;
      padding: 10px;
      margin-left: -10px;
      margin-right: -10px;
      transition: all 0.25s ease;
    }

    .product-card--section:not(.is-expanded) .product-card--section-caption:after,
    .product-card--section:not(.is-expanded) .subcaption:after,
    .product-card-aside--block:not(.is-expanded) .product-card--section-caption:after,
    .product-card-aside--block:not(.is-expanded) .subcaption:after {
      -moz-transform: rotate(-45deg) translate(-50%, -50%);
      -ms-transform: rotate(-45deg) translate(-50%, -50%);
      -o-transform: rotate(-45deg) translate(-50%, -50%);
      -webkit-transform: rotate(-45deg) translate(-50%, -50%);
      transform: rotate(-45deg) translate(-50%, -50%);
      transform-origin: top left;
    }

    .product-card--section:not(.is-expanded) .product-card--section-content,
    .product-card--section:not(.is-expanded) .block--content,
    .product-card-aside--block:not(.is-expanded) .product-card--section-content,
    .product-card-aside--block:not(.is-expanded) .block--content {
      max-height: 0;
      opacity: 0;
      padding-top: 0;
      padding-bottom: 0;
    }

    .product-card--section.is-expanded .product-card--section-caption:after,
    .product-card--section.is-expanded .subcaption:after,
    .product-card-aside--block.is-expanded .product-card--section-caption:after,
    .product-card-aside--block.is-expanded .subcaption:after {
      -moz-transform: rotate(45deg) translate(-50%, -50%);
      -ms-transform: rotate(45deg) translate(-50%, -50%);
      -o-transform: rotate(45deg) translate(-50%, -50%);
      -webkit-transform: rotate(45deg) translate(-50%, -50%);
      transform: rotate(45deg) translate(-50%, -50%);
      transform-origin: top left;
    }

    .product-card--section.is-expanded .product-card--section-content,
    .product-card--section.is-expanded .block--content,
    .product-card-aside--block.is-expanded .product-card--section-content,
    .product-card-aside--block.is-expanded .block--content {
      border-bottom: 1px solid #b7b6b6;
    }

    .sizes-table-btn,
    .product-card--action-link {
      display: block;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.2;
      text-align: center;
      padding: 15px 25px;
      border-top: 1px solid #b7b6b6;
      border-bottom: 1px solid #b7b6b6 !important;
      color: #000 !important;
      margin-left: -10px;
      margin-right: -10px;
      position: relative;
    }

    .sizes-table-btn:after,
    .product-card--action-link:after {
      content: '';
      display: block;
      width: 5px;
      height: 5px;
      border-bottom: 3px solid #d7d7d7;
      border-right: 3px solid #d7d7d7;
      position: absolute;
      right: 12px;
      top: 50%;
      -moz-transform: rotate(-45deg) translate(-50%, -50%);
      -ms-transform: rotate(-45deg) translate(-50%, -50%);
      -o-transform: rotate(-45deg) translate(-50%, -50%);
      -webkit-transform: rotate(-45deg) translate(-50%, -50%);
      transform: rotate(-45deg) translate(-50%, -50%);
      transform-origin: top left;
    }

    .size-choice-block {
      padding-bottom: 10px;
    }

    .product-card-aside--block.not-collapsible {
      padding: 15px 0 0;
    }
  }

  .product-card {
    position: relative;
  }

  @media only screen and (min-width: 481px) {
    .product-card {
      display: -ms-flex;
      display: -webkit-flex;
      display: flex;
      justify-content: space-between;
    }
  }

  .product-card .product-right-col {
    position: relative;
  }

  @media only screen and (min-width: 481px) {
    .product-card .product-right-col {
      float: right;
      width: 50%;
      margin-left: 20px;
    }

    .product-card .product-right-col .product-left-col,
    .product-card .product-right-col .product-right-col {
      width: calc(50% - 12px);
      margin-left: 0;
    }
  }

  .product-card .product-left-col {
    position: relative;
  }

  @media only screen and (min-width: 481px) {
    .product-card .product-left-col {
      float: left;
      width: 50%;
      padding-bottom: 60px;
    }
  }

  .product-card .product-main-pic {
    display: block;
    padding-bottom: 37%;
    position: relative;
  }

  .product-card .product-main-pic img {
    position: absolute;
    left: 50%;
    top: 50%;
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
  }

  .product-card .product-carousel {
    font-size: 0;
    margin-bottom: 20px;
    box-sizing: border-box;
  }

  .product-card .product-carousel.no-carousel {
    padding-left: 0;
    padding-right: 0;
  }

  @media only screen and (max-width: 480px) {
    .product-card .product-carousel .carousel-container {
      height: auto;
    }

    .product-card .product-carousel .carousel {
      display: inline-block;
      width: auto !important;
      position: relative;
      left: 50% !important;
      transform: translateX(-50%);
    }
  }

  .product-card .product-carousel li {
    list-style: none;
    display: inline-block;
    vertical-align: middle;
    width: 16.66%;
    opacity: 0.5;
  }

  .product-card .product-carousel li.active {
    opacity: 1;
  }

  @media only screen and (max-width: 800px) {
    .product-card .product-carousel li {
      line-height: 50px !important;
      border: 1px solid transparent;
    }

    .product-card .product-carousel li.active {
      border-color: #ffcc08;
    }
  }

  .product-card .product-carousel li img {
    max-width: 100%;
    max-height: 65px;
  }

  @media only screen and (max-width: 480px) {
    .product-card .product-carousel li {
      width: auto !important;
      height: auto !important;
      opacity: 1;
      float: none;
      margin-bottom: 0 !important;
      vertical-align: top;
    }

    .product-card .product-carousel li + li {
      margin-left: 5px;
    }

    .product-card .product-carousel li a {
      display: block;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      width: auto !important;
      height: auto !important;
    }

    .product-card .product-carousel li a img {
      width: 50px !important;
      height: 50px !important;
      object-fit: contain;
    }
  }

  @media only screen and (min-width: 1200px) {
    .product-card .product-carousel.no-carousel li {
      width: 120px;
    }
  }

  .product-card .product-article {
    font-size: 12px;
  }

  .product-card .product-icons span {
    margin-right: -7px;
  }

  .mobile .product-card .product-colors-wrapper {
    margin-bottom: 25px;
  }

  .product-card .product-colors {
    margin-bottom: 30px;
    max-width: 220px;
  }

  .product-card .product-colors .color {
    text-align: center;
    border: 1px solid transparent;
  }

  .product-card .product-colors .color img {
    max-width: 90%;
    max-height: 90%;
  }

  .product-card .product-colors .color.active {
    border-color: #ffcc08;
  }

  .product-card .product-colors .color.active:before {
    display: none;
  }

  @media only screen and (max-width: 480px) {
    .product-card .product-colors {
      font-size: 0;
    }

    .product-card .product-colors .color-wrapper + .color-wrapper {
      margin-left: 0;
    }

    .product-card .product-colors .color {
      width: 20%;
      height: auto;
      padding-bottom: 20%;
      position: relative;
    }

    .product-card .product-colors .color img {
      position: absolute;
      left: 50%;
      top: 50%;
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
  }

  .product-card + .avail-block {
    display: none;
    font-size: 12px;
    line-height: 120%;
    margin: -10px 0 10px;
  }

  .product-card + .avail-block.product-avail {
    display: block;
  }

  .product-card + .avail-block .inner {
    float: right;
    width: 298px;
  }

  .product-card + .avail-block .warehouse,
  .product-card + .avail-block .eshop {
    padding-left: 30px;
    min-height: 20px;
    margin-bottom: 5px;
  }

  .product-card + .avail-block .warehouse {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAAAuklEQVR42mNgoBx4A/EWIK6mxBBpID4GxEuBeCYQt5NrkD0Q3wZiP3SJ/2RgkEFaGFYcPHjw6dq1a/+Tgm/dunUKl5PrSHTVWyDmxGWYKymuOnny5G18gSlKosu08EbNtm3bPhPjqt27d7/5////WkJRvZpIV+UTk26MgTiNAAYZdBKImRmoBHKAOJOBimAONCthB/9JABs3brwDzY84QQUZWcobn4G3gPgbEF+jUA0Y5AHxTWggk6UGAKm99MHenxdeAAAAAElFTkSuQmCC)
      no-repeat 2px 0;
  }

  .product-card + .avail-block .eshop {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAANCAYAAACkTj4ZAAAAO0lEQVR42mNgYGA4DMT/KcQgMxj+UwqghkEMWrt2LQomRWyQGzQaRvQJo11USNkgMwgCuI3kAly2YwUAk4w1b7q4i8gAAAAASUVORK5CYII=)
      no-repeat 0 2px;
  }

  @media only screen and (max-width: 480px), only screen and (max-device-width: 480px) {
    .product-card + .avail-block {
      font-size: 18px;
      margin: 50px 0 10px;
      text-align: center;
    }

    .product-card + .avail-block .inner {
      float: none;
      width: 100%;
    }

    .product-card + .avail-block .warehouse,
    .product-card + .avail-block .eshop {
      background: none;
      text-align: left;
      margin-bottom: 15px;
    }
  }

  .product-brand {
    text-align: center;
    position: relative;
    overflow: hidden;
  }

  .product-brand > a {
    display: block;
    width: 260px;
    height: 152px;
  }

  .sizes-table-btn {
    color: #000;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.5);
    line-height: 1;
  }

  .sizes-table-btn:hover {
    color: #ffcc08;
    border-bottom-color: rgba(255, 204, 8, 0.5);
  }

  .size-choice-block .size {
    display: inline-block;
    vertical-align: top;
    height: 19px;
    line-height: 19px;
    font-size: 16px;
    font-weight: 500;
    padding: 0 8px;
    text-decoration: none;
    cursor: pointer;
    color: #000;
    margin-bottom: 5px;
  }

  .size-choice-block .size.active {
    background: #ffcc08;
  }

  .size-choice-block .size.disabled {
    font-weight: normal;
    color: #bbb;
    background: #fff;
  }

  .size-choice-block .size-choice-chart {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 101%;
    background: #000;
    padding: 7px 12px;
    position: absolute;
    left: 100%;
    bottom: 0;
    margin-left: 1px;
  }

  .size-choice-block .size-choice-chart .sizes-chart th,
  .size-choice-block .size-choice-chart .sizes-chart td {
    padding: 10px;
    line-height: 100%;
  }

  .size-choice-block .size-choice-chart .sizes-chart th {
    border-top: none;
  }

  .size-choice-block .size-choice-chart .sizes-chart tr:last-child td {
    border-bottom: none;
  }

  .product-card .size-choice-block .size {
    display: inline-block;
    vertical-align: top;
    min-width: 38px;
    height: 38px;
    line-height: 38px;
    padding: 0 4px;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
    color: #000;
    text-align: center;
    box-sizing: border-box;
    outline: 1px solid #e2e4e6;
    margin: 0;
    margin-top: 1px;
    outline: 1px solid #e2e4e6;
    margin-left: -2.5px;
  }

  .product-card .size-choice-block .size.active {
    background: #ffcc08;
  }

  .product-card .size-choice-block .size.disabled {
    font-weight: normal;
    color: #bbb;
    background: #fff;
  }

  .product-card .size-choice-block .size.size--certificate {
    outline: none;
    padding: 0;
    position: relative;
    cursor: default;
  }

  .product-card .size-choice-block .size.size--certificate.stretched {
    display: flex;
    margin: 0 10px !important;
    width: auto !important;
  }

  .product-card .size-choice-block .size.size--certificate::after {
    content: 'Другая сумма';
    display: block;
    width: 100%;
    position: absolute;
    bottom: -16px;
    left: 50%;
    font-size: 13px;
    transform: translateX(-50%);
    line-height: 10px;
  }

  .product-card .size-choice-block .size.size--certificate input {
    position: absolute;
    bottom: 0;
    left: 0;
    outline: none;
    border: 0;
    border-bottom: 1px solid #e2e4e6;
    width: 100%;
    height: 60%;
    font-size: 16px;
    text-align: center;
  }

  @media only screen and (max-width: 480px) {
    .certificate--image {
      max-width: 100% !important;
    }
  }

  .card-btn {
    font-size: 27px;
    margin-right: 5px;
    height: 49px;
    line-height: 45px;
    min-width: 206px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    box-sizing: border-box;
  }

  .product-card .card-btn + .card-btn {
    margin-top: 7px;
  }

  .card-btn.buy-btn + .buy-btn,
  .card-btn.cornered-btn + .buy-btn,
  .card-btn.next-step-btn + .buy-btn,
  .card-btn.next-halfstep-btn + .buy-btn,
  .card-btn.buy-btn + .cornered-btn,
  .card-btn.cornered-btn + .cornered-btn,
  .card-btn.next-step-btn + .cornered-btn,
  .card-btn.next-halfstep-btn + .cornered-btn,
  .card-btn.buy-btn + .next-step-btn,
  .card-btn.cornered-btn + .next-step-btn,
  .card-btn.next-step-btn + .next-step-btn,
  .card-btn.next-halfstep-btn + .next-step-btn,
  .card-btn.buy-btn + .next-halfstep-btn,
  .card-btn.cornered-btn + .next-halfstep-btn,
  .card-btn.next-step-btn + .next-halfstep-btn,
  .card-btn.next-halfstep-btn + .next-halfstep-btn {
    margin-top: 0;
  }

  .card-btn.buy-btn,
  .card-btn.cornered-btn,
  .card-btn.next-step-btn,
  .card-btn.next-halfstep-btn {
    margin-bottom: 12px;
  }

  .card-btn.fast-order-btn {
    background: #847e7e;
    color: #fff;
    font-size: 16px;
    width: auto;
    min-width: 0;
  }

  .card-btn.fast-order-btn:hover {
    background: #777171;
  }

  .product-card--buttons-row {
    display: -ms-flex;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    align-items: center;
    flex: 1;
  }

  @media only screen and (max-width: 800px) {
    .product-card--buttons-row {
      margin-bottom: 15px !important;
    }
  }

  .warehouse {
    margin-bottom: 10px;
  }

  .warehouse a {
    display: inline-block;
    line-height: 1;
    color: #000;
    font-size: 15px;
    text-decoration: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  }

  .main-tabs.card-tabs .ui-tabs-nav {
    margin-bottom: 0;
    display: table;
    width: 100%;
  }

  .main-tabs.card-tabs .ui-tabs-nav:before,
  .main-tabs.card-tabs .ui-tabs-nav:after {
    display: none;
  }

  .main-tabs.card-tabs .ui-tabs-nav li {
    display: table-cell;
    text-align: center;
  }

  .main-tabs.card-tabs .ui-tabs-nav li + li {
    border-left: 1px solid #fff;
  }

  .main-tabs.card-tabs .ui-tabs-nav a span {
    height: 41px;
    line-height: 41px;
    font-size: 19px;
  }

  .main-tabs.card-tabs .ui-tabs-nav .ui-tabs-active a span {
    height: 46px;
    line-height: 46px;
    font-size: 19px;
    font-weight: 600;
  }

  @media only screen and (min-width: 481px) {
    .main-tabs.card-tabs .tab-panel {
      border: 1px solid #ffcc08;
      padding: 28px;
    }
  }

  @media only screen and (max-width: 480px) {
    .main-tabs.card-tabs .tab-panel {
      border-bottom: 1px solid #e2e4e6;
    }
  }

  .review-block img {
    max-width: 100%;
  }

  .review-block .review-caption span {
    border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  }

  .review-block .review-caption:hover {
    color: #ffcc08;
  }

  .review-block .review-caption:hover span {
    border-bottom-color: rgba(255, 204, 8, 0.5);
  }

  .description-main {
    display: none;

    @media (${media.md}) {
      display: initial;
    }
  }

  .description-aside {
    display: flex;

    @media (${media.md}) {
      display: none;
    }
  }

  .product-card {
    align-items: center;
    gap: 20px;
    width: 100%;

    .product-card--main-col {
      max-width: unset;
      width: 100%;
    }

    .product-image {
      width: 100%;

      @media ${media.md} {
        width: initial;
      }
    }

    .product-card--aside {
      width: 100%;
    }

    @media ${media.md} {
      align-items: initial;
      width: initial;

      .product-card--aside {
        max-width: 300px;
      }
    }
  }
`

export const CertificatesSelectorTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 12px;
`

export const CertificateAmount = styled(Input)`
  width: 100%;
`
export const CertificateButton = styled(Button)`
  background: ${theme.colors.foreground};

  ${props =>
    props.primary &&
    css`
      background: ${theme.colors.primary};

      &:hover {
        &.ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
          background: ${theme.colors.primary};
        }
      }
    `}
`

export const SubmitButton = styled(Button)`
  margin-top: 10px;
`

export const SideIncludeAreas = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const ContactUs = styled.div`
  line-height: 1.4rem;
`

export const ShipmentInfo = styled.div`
  line-height: 1.4rem;
`

export const GalleryWrapper = styled.div`
  margin-bottom: 32px;
`
